import { request } from '@/shared/api/request'

export const getXML = () => {
	return request({ url: `/user/get/xmlForSign`, method: 'GET' })
}
